import { Icon } from '@types';

export const Droplet = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 47.88 77.37"
		>
			<defs>
				<style>
					{
						'.cls-droplet{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}'
					}
				</style>
			</defs>
			<path
				className="cls-droplet"
				d="M23.94,1s22.94,32.77,22.94,50.8c0,20.81-16.39,24.58-22.94,24.58S1,72.61,1,51.8C1,33.77,23.94,1,23.94,1Z"
			/>
			<path className="cls-droplet" d="M38.35,54.56c-1.24,7.58-5.7,10.96-9.68,12.45" />
		</svg>
	);
};
